import styled from '@emotion/styled';

interface IconWrapperProps {
  direction: 'left' | 'right';
  disabled?: boolean;
}

const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ direction }) => (direction === 'left' ? 'rotate(180deg)' : 'none')};
`;

interface ArrowIconProps {
  direction: 'left' | 'right';
  disabled?: boolean;
}

export const ArrowIcon = ({ direction, disabled }: ArrowIconProps) => {
  return (
    <IconWrapper direction={direction} disabled={disabled}>
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.04492 10.501H16.7116M16.7116 10.501L10.8783 4.66763M16.7116 10.501L10.8783 16.3343"
          stroke={disabled ? '#C4C4C4' : '#303030'}
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};
